import { Pipe, PipeTransform } from '@angular/core';
 
@Pipe({
 name: 'labelFormat'
})
export class LabelFormat implements PipeTransform {
 transform(value: any): any {
	return value.replace(/(?:_| |\b)(\w)/g, function(d){return d.toUpperCase().replace('_',' ');});
 }
}